import CreditsHero from './CreditsHero';
import CreditsReadout from './CreditsReadout';
import CreditsTrack from './CreditsTrack';
import CreditsTicks from './CreditsTicks';
import CreditsFooter from './CreditsFooter';
import { Body, CardRoot, FinePrint } from './styles/CreditsSlider.styles';
import { SliderBox } from './styles/CreditsTrack.styles';
import type { CreditsSliderProps } from './types';

const DEFAULT_FINEPRINT =
  'Use credits for job applications, courses and competitions.';

const CreditsSlider = ({
  tiers,
  selectedId,
  onSelect,
  onAddToCart,
  addingToCart,
  addToCartDisabled,
  ctaLabel,
  compact,
  title = 'Buy credits',
  subtitle = 'Slide to choose your pack — the more you buy, the bigger the bonus.',
  fineprint = DEFAULT_FINEPRINT,
  onClose,
  asChild,
}: CreditsSliderProps) => {
  if (tiers.length === 0) return null;

  const activeIndex = Math.max(
    0,
    tiers.findIndex((tier) => tier.id === selectedId),
  );
  const activeTier = tiers[activeIndex];

  const selectIndex = (index: number) => {
    const tier = tiers[index];
    if (tier) onSelect(tier.id);
  };

  return (
    <CardRoot compact={compact} asChild={asChild}>
      <CreditsHero
        title={title}
        subtitle={subtitle}
        compact={compact}
        onClose={onClose}
      />
      <Body compact={compact}>
        <CreditsReadout tier={activeTier} compact={compact} />
        <SliderBox compact={compact}>
          <CreditsTrack
            index={activeIndex}
            tierCount={tiers.length}
            onIndexChange={selectIndex}
          />
          <CreditsTicks
            tiers={tiers}
            activeIndex={activeIndex}
            onSelectIndex={selectIndex}
            compact={compact}
          />
        </SliderBox>
        <CreditsFooter
          tier={activeTier}
          onAddToCart={onAddToCart}
          addingToCart={addingToCart}
          addToCartDisabled={addToCartDisabled}
          ctaLabel={ctaLabel}
          compact={compact}
        />
        <FinePrint compact={compact}>{fineprint}</FinePrint>
      </Body>
    </CardRoot>
  );
};

export default CreditsSlider;
export type { CreditsTier, CreditsSliderProps } from './types';
export { itemToCreditsTier } from './utils';
export type { CreditsSourceItem } from './utils';
